










































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseModal from "@/resources/components/BaseModal.vue";
import Question from "@/app/models/Question";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import Index from '@/resources/views/Questions/Index.vue';
import MultiSelect from "@/resources/components/MultiSelect.vue";
import ProductType from "@/app/models/ProductType";
import Debounce from "@/app/support/Debounce";
import Part from "@/app/models/Part";
import Cross from "@/assets/svg/cross.svg";
import QuestionButtons from "@/resources/components/QuestionButtons.vue";
import Answer from "@/app/models/Answer";

@Component({
    components: {
        QuestionButtons,
        MultiSelect,
        "base-modal"     : BaseModal,
        "loading-overlay": LoadingOverlay,
        Cross,
    },
})
export default class CreateOrEdit extends Vue {
    originalQuestion: string = '';
    question: Question = new Question({
        yes_required           : false,
        no_required            : false,
        not_applicable_required: false,
        image_required         : false,
        image_only             : false,
        show_explanation       : false,
        is_header_text         : false,
        order                  : 1,
    });

    availableParts: Part[] = [];
    searchParts: string = '';

    $parent!: Index;

    get productTypes(): ProductType[] {
        return this.$store.getters.productTypes;
    }

    get questionProductTypes(): string[] {
        return this.question.productTypes.map((productType: ProductType) => {
            return productType.id!.toString();
        });
    }

    set questionProductTypes(ids: string[]) {
        this.question.productTypes = ids.map((id: string) => {
            return this.productTypes.find((productType: ProductType) => {
                return productType.id!.toString() === id;
            });
        }) as ProductType[];
    }

    get shouldShowPartsSelection(): boolean {
        return !this.question.is_scaffoldless_station && !this.question.is_header_text;
    }

    mounted() {
        this.question.station_id = parseInt(this.$route.params.station);

        if (this.$route.params.question != null) {
            this.task(async () => {
                const data = await Question.show(parseInt(this.$route.params.question));

                if (data instanceof Question) {
                    this.question = data;
                    this.originalQuestion = data.question;
                }
            });
        }
    }

    deletePart(part: Part) {
        this.question.parts!.splice(this.question.parts!.indexOf(part), 1);
    }

    submit() {
        this.task(async () => await this.question.save())
            .then(() => this.close());
    }

    destroy() {
        if (confirm(this.$t('Weet u zeker dat u deze vraag wilt verwijderen?') as string)) {
            this.task(async () => await this.question.destroy())
                .then(() => this.close());
        }
    }

    close() {
        // @ts-ignore
        this.$parent.reset();
        this.$router.push(this.$route.matched.slice(-2)[0])
    }

    disableImageOnlyIf(condition: boolean) {
        if (condition) {
            this.question.image_only = false;
        }
    }

    @Watch('question.image_only')
    onImageOnlyUpdated(imageOnly: boolean) {
        if (imageOnly) {
            this.question.yes_required = false;
            this.question.no_required = false;
            this.question.not_applicable_required = false;
            this.question.image_required = true;
        }
    }

    @Watch('question.is_header_text')
    onIsHeaderTextUpdated(isHeaderText: boolean) {
        if (isHeaderText) {
            this.question.subtitle = null;
            this.question.image_only = false;
            this.question.image_required = false;
            this.question.yes_required = false;
            this.question.no_required = false;
            this.question.not_applicable_required = false;
            this.question.show_explanation = false;
            this.question.parts = [];
            this.question.productTypes = [];
        }
    }

    @Debounce(250)
    fetchParts() {
        this.task(async () => {
            await Part.index(1, {
                take  : 5000,
                search: this.searchParts,
            }).then(
                (data) => {
                    this.availableParts = data.data as Part[];

                    for (let part of this.question.parts) {
                        const index = this.availableParts.findIndex((p: Part) => p.id === part.id);

                        if (index > -1) {
                            this.availableParts[index] = part;
                            continue;
                        }

                        this.availableParts.push(part);
                    }
                }
            );
        });
    }
}
